import { createApp } from "vue";
import VueGoodTablePlugin from 'vue-good-table-next';


// import the styles
import 'vue-good-table-next/dist/vue-good-table-next.css'

// Vue.use(VueGoodTablePlugin);
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/style.css";
import ArgonDashboard from "./argon-dashboard";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueGoodTablePlugin);
appInstance.mount("#app");
